import React from "react";
import { useSelector } from "react-redux";
 
const DevicesStatistics = (  ) => {
   var { devices }  =  useSelector((state) => state.utilities);
  var  active  =  devices !== null ? devices?.filter(device=>{ return device.deviceStatus === '1'}).length : 0
  var  inActive  =  devices !== null ? devices?.filter(device=>{ return device.deviceStatus === '2'}).length : 0
  var  pending  =  devices !== null ? devices?.filter(device=>{ return device.deviceStatus === '3'}).length : 0
  var  suspended  =  devices !== null ? devices?.filter(device=>{ return device.deviceStatus === '4'}).length : 0

   return (
       
    <div class="row g-4 mb-4">
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Acive Devices</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{active}</h4>
               </div>
             </div>
            <span class="badge bg-label-success rounded p-2">
              <i class="bx bx-devices bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
 
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>InActive Devices</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{inActive}</h4>
               </div>
             </div>
            <span class="badge bg-label-secondary rounded p-2">
              <i class="bx bx-devices bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Pending Devices</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{pending}</h4>
               </div>
             </div>
            <span class="badge bg-label-warning rounded p-2">
              <i class="bx bx-devices bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xl-3">
      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between">
            <div class="content-left">
              <span>Suspended Devices</span>
              <div class="d-flex align-items-end mt-2">
                <h4 class="mb-0 me-2">{suspended}</h4>
               </div>
             </div>
            <span class="badge bg-label-danger rounded p-2">
              <i class="bx bx-devices bx-sm"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
   );
};

export default DevicesStatistics;
